import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { PageWrapper } from '@/components/__UI'
import { StyledContainer } from './CookiePolicyPage.styles'

const CookiePolicyPage = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <PageWrapper
      title='Cookie policy'
    >
      <StyledContainer>
        <p>
          BY USING THIS WEBSITE, YOU SIGNIFY YOUR ACCEPTANCE OF THE USE OF COOKIES ON THIS WEBSITE,
          AS SET OUT IN THIS COOKIE POLICY. IF YOU DO NOT ACCEPT THE USE OF COOKIES ON THIS WEBSITE AS DESCRIBED,
          PLEASE STOP USING THIS WEBSITE OR DISABLE THE RELEVANT COOKIES. YOUR CONTINUED USE OF THIS WEB SITES
          FOLLOWING THE POSTING OF CHANGES TO THIS COOKIE POLICY WILL MEAN THAT YOU ACCEPT THOSE CHANGES.
        </p>

        <h3>1. What are cookies and how are they used on this website?</h3>
        <p>
          Cookies are text files generated by a website and placed on your computer or on any other device
          you are using to access the website. Cookies are used on this website for various purposes including,
          for example, to evaluate, develop and track website usage, improve the user experience and facilitate accommodation bookings,
          help your browser navigate through this website, and collect standard internet log information and visitor behaviour information.
          Cookies from third parties facilitate targeted marketing on this and other websites and they (including those set by Google Analytics Premium – see Section 2)
          are used to evaluate and compile statistical reports for us on website activity. Section 2 and the table below contain further details about the cookies used and their purposes.
        </p>

        <p>
          Most of the cookies on this website do not capture a {`user's`} name or other information that would identify the user personally.
          They merely identify a computer or other device. All information collected by cookies on this website is aggregated and therefore anonymous.
        </p>

        <p>
          However, some cookies operated by our technology providers (such as Google, Hotjar and Fresh Relevance) may collect certain personal information.
          Please see below for an explanation of how you can find out details on and manage these cookies.
        </p>

        <p>Information collected by the marketing cookies on this website will be disclosed to third parties. See the table below.</p>

        <p>
          Session cookies store information locally on your device for the duration of your visit and expire at the end of your browsing session,
          i.e. when you close your browser window the session, cookie and information it collected is deleted. Persistent cookies are stored on
          your computer or other device and they remain there after you close your session until you delete them manually or until your browser deletes
          them based on the pre-determined period contained within the persistent {`cookie's`} file.
        </p>

        <p>
          This website uses both first party and third party cookies, see the table below. Section 2 below contains detailed information
          about the use of third party cookies in particular marketing and analytics cookies.
        </p>

        <p>We have decided to categorise cookies used on our website based on the UK International Chamber of {`Commerce's`} cookie guide, as follows:</p>

        <p>Cookies {`"strictly necessary"`} for functionality of this {`website's`} platform. These cookies are essential in order to enable users to move around this website and use its features.</p>

        <p>
          <b>{`"Performance"`}</b> cookies which collect information about how users navigate this website, for instance which pages users access most frequently.
          They identify how users interact with our website, find out which pages seem to hold people up, which pages are not used often, which pages take a long time to load,
          what pages users tend to visit and in what order. All of this helps us to refine and develop our website to try and make them more usable when a user visits us again in future.
        </p>

        <p>
          <b>{`"Functionality"`}</b> cookies which allow this website to remember choices you make. For example, this can be the last date you’ve searched for or the last holiday you’ve viewed.
        </p>

        <p>
          <b>{`"Targeting or advertising"`}</b> cookies used to deliver adverts relevant to an identified machine or other device (not a named or otherwise identifiable person) which are tailored
          to interests associated with the website activity tied to that machine or device. These cookies are also used to limit the number of times a user sees an advertisement as well as to
          help measure the effectiveness of the advertising campaign. They may also remember that this website has been visited from a device and share that information with marketing organisations.
          The marketing cookies on this website are operated by third parties with our permission. Marketing cookies are used to monitor from which advertising source a user was directed towards our website,
          so that we know whether it is worth us investing in that particular advertising source.
        </p>

        <p>
          For more general information about cookies and how to disable them through your browser, visit <a title="All about cookies" href="https://www.allaboutcookies.org" rel="noopener noreferrer" target="_blank">www.allaboutcookies.org</a>.
          Contact us (see Section 5) if you have questions about the cookies used on this website.
        </p>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Cookie type</th>
                <th>Cookie purpose</th>
                <th>
                  <p>
                Life of cookie: persistent or session?
                    <br/>
                First of third party cookie?
                  </p>
                </th>
                <th>
                  <p>Category of cookie as defined in the ICC UK Cookie Guide</p>
                </th>
                <th><p>Privacy impact (low/mid/high)</p></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><p><b>Essential transactional functionality</b></p></td>
                <td>
                  <p>
                  Essential for core shopping and booking functions, primarily to maintain navigation state and accommodation booking information during a browser session.
                  Without this cookie the booking process on this website will not function.
                  </p>
                </td>
                <td>
                  <p>
                  Session
                    <br />
                  First party
                  </p>
                </td>
                <td><p>Essential and functionality</p></td>
                <td><p>Low – Technical details only relating to shopping basket requirements.</p></td>
              </tr>
              <tr>
                <td><p><b>Supporting transactional functionality</b></p></td>
                <td><p>Supports the core shopping and booking functions (see above)</p></td>
                <td><p>Persistent for up to 24 months after a browser session is ended</p></td>
                <td><p>Functionality</p></td>
                <td><p>Low - Non personal</p></td>
              </tr>
              <tr>
                <td><p><b>Navigation analytics</b></p></td>
                <td>
                  <p>
                  To evaluate a {`user's`} use of this website and compile reports on user activity.
                  A third party (e.g. Google) stores the information collected by the cookie.
                  It may disclose the information to third parties where required by law or where such third parties process the information on our behalf.
                    <br />
                  The data collected is used for managing the performance and design of this website.
                    <br />
                  See Section 2 for further information about Google analytics premium in particular.
                  </p>
                </td>
                <td>
                  <p>
                  Persistent for up to 24 months after a browser session is ended.
                    <br />
                  First party and third party.
                    <br />
                  Third party - Certain 3rd party cookies (e.g WhosOn (webchat), Pinterest, and Youtube/Google Ad Services cookies)
                  have lifetimes of over 24 months. Please see the 3rd party’s own Cookie Notice for full information.
                  </p>
                </td>
                <td><p>Performance</p></td>
                <td><p>Mid - Non personal</p></td>
              </tr>
              <tr>
                <td><p><b>Marketing and merchandising</b></p></td>
                <td>
                  <p>
                  See ICC description of {`"Targeting or advertising"`} cookies above.
                    <br />
                  See Section 2 for further information about how Google in particular displays adverts for Vacation Rentals (UK)
                  Ltd on third party websites and how data collected by Google is combined and used with data about our adverts.
                  </p>
                </td>
                <td>
                  <p>
                  First Party Persistent for up to 24 months after a browser session is ended.
                    <br />
                  Third party - Certain 3rd party cookies (e.g WhosOn (webchat), Pinterest, and Youtube/Google Ad Services cookies) have lifetimes of over 24 months.
                  Please see the 3rd party’s own Cookie Notice for full information
                  </p>
                </td>
                <td><p>Targeting or advertising</p></td>
                <td>
                  <p>High – tracking of user behaviour across multiple third party website in order to tailor advertisements on this website to the user.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3>2. Technology providers</h3>

        <h4>Google</h4>
        <p>
          This website uses Google Analytics Premium, a web analytics service provided by Google Ireland Limited ({`"Google"`}).
          Google Analytics Premium uses {`"cookies"`} (as described above and in particular, the navigation analytics cookie described in the table)
          to help us analyse how the site is used. The information generated by those cookies about your use of this website and your current IP-address will be
          transmitted by your browser to and will be stored by Google on servers in the United States and other countries. Google will use this information on our behalf
          for the purpose of evaluating your use of this website, compiling reports on website activity and providing other services relating to website activity and internet usage to us.
          You may choose not to opt-in to permit use of the Google cookies and thereafter you can prevent that use by selecting the appropriate settings on your browser,
          however please note that if you do this you may not be able to use the full functionality of this website (see Section 9 above).
          You may also stop the transmission of information generated by the cookies about your use of this website and of your IP address to Google,
          by downloading and installing the Google Analytics Opt-out Browser Add-on available here: <a title="GA-opt-out" href="http://tools.google.com/dlpage/gaoptout">http://tools.google.com/dlpage/gaoptout</a>.
        </p>

        <p>Google also displays adverts for Vacation Rentals (UK) Ltd on third party websites.</p>

        <p>Google will use cookies to display adverts on those third party websites which may take into account a {`user's`} prior visits to this website.</p>

        <p>
          You may reject or delete the Google advertising cookie i.e. you may opt out of {`Google's`} interest-based advertising program by visiting the
          Google advertising opt-out page <a title="Google ad settings" href="https://adssettings.google.co.uk/anonymous">https://adssettings.google.co.uk/anonymous</a>
        </p>

        <p>
          We combine data collected by Google Analytics Premium, with data about our adverts that have been shown using the Google Display Network or DoubleClick for Advertisers,
          to understand how anonymous users interact with this website after seeing our adverts. We do this to analyse and optimise our advertising campaigns.
        </p>

        <h4>HotJar</h4>
        <p>This service provides website heat maps, conversion funnels, session replays and form analytics to help us make our website more usable for you.</p>

        <p>If you would like to opt out, you can do so here: <a title="HotJar opt out" href="https://www.hotjar.com/legal/compliance/opt-out">https://www.hotjar.com/legal/compliance/opt-out</a></p>

        <h4>Fresh Relevance</h4>
        <p>
            This service helps us manage promotions and merchandise we display on the website (banners, select properties, etc.)
            and allows us to email you a reminder if you have started (and filled in your email address), but not completed your booking.
            If you are browsing our website and we have collected your email address, we may email you to remind you where you left off on your browsing journey.
            This is an essential part of our service to you which helps us provide good user experience.
            To manage your cookie preferences, please see their cookie policy: <a title="Fresh Relevance cookie policy" href="https://www.freshrelevance.com/cookies-policy">https://www.freshrelevance.com/cookies-policy</a>
        </p>

        <h3>3. Does the policy apply to linked websites?</h3>
        <p>Our websites may contain links to other websites. This cookie policy only applies to this website so when you link to other websites you should read their own cookie policies.</p>

        <h3>4. How do we update this cookie policy?</h3>
        <p>We keep our cookie policy under regular review and we will place any updates on our webpage. This cookie policy was last updated in May 2018.</p>

        <h3>5. Who can I contact if I have queries about this cookie policy?</h3>
        <p>Please contact us if you have any questions about our cookie policy or information we hold about you.</p>
        <p>By email: <a href="mailto:datachanges@awaze.co.uk">datachanges@awaze.co.uk</a></p>
        <p>Or write to us at: Vacation Rentals (UK) Ltd, Spring Mill, Earby, Barnoldswick, Lancashire, BB94 0AA, United Kingdom.</p>

      </StyledContainer>
    </PageWrapper>
  )
}

export default CookiePolicyPage
